// Mensajes del seguimiento de la prueba gratis (días 1, 7 y 13).
// Los usa: el aviso dentro de Kontrol (MensajePrueba), la lista de WhatsApp
// del panel Admin y el correo automático (api/cron-seguimiento repite los textos).

export const ETAPAS = {
  1: { nombre: 'Bienvenida', emoji: '👋' },
  7: { nombre: 'Mitad de la prueba', emoji: '💡' },
  13: { nombre: 'Se acaba la prueba', emoji: '⏳' },
};

// Etapa según el día de prueba (igual que etapa_de_prueba() en la BD).
export function etapaPorDia(dia) {
  if (dia >= 1 && dia <= 3) return 1;
  if (dia >= 7 && dia <= 9) return 7;
  if (dia >= 12 && dia <= 14) return 13;
  return null;
}

// Día de prueba a partir de prueba_hasta (la prueba dura 14 días).
export function diaDePrueba(pruebaHasta) {
  const inicio = new Date(pruebaHasta).getTime() - 14 * 86400000;
  return Math.floor((Date.now() - inicio) / 86400000) + 1;
}

// Texto de WhatsApp que la admin envía desde el panel.
export function mensajeWhatsApp(etapa, negocio) {
  const n = negocio || 'tu negocio';
  if (etapa === 1) {
    return `¡Hola! 👋 Soy Merly, de Kontrol. Vi que acabas de crear la cuenta de ${n}. ¡Te damos la bienvenida!\n\n`
      + 'Para empezar con el pie derecho te recomiendo 3 cosas:\n'
      + '1️⃣ Agrega 3 o 4 de tus productos o servicios más vendidos\n'
      + '2️⃣ Haz tu primera venta desde "Vender"\n'
      + '3️⃣ Comparte tu catálogo en línea con tus clientes\n\n'
      + 'Si te trabas en algo, escríbeme por aquí y te ayudo. 💜';
  }
  if (etapa === 7) {
    return `¡Hola! 😊 ¿Cómo te va con Kontrol en ${n}? Ya vas a la mitad de tu prueba gratis.\n\n`
      + '¿Ya probaste estas funciones?\n'
      + '📊 Reportes: qué productos te dejan más ganancia\n'
      + '☀️ Corte del día: cuadrar la caja en 1 minuto\n'
      + '🛍️ Catálogo en línea: tus clientes piden desde su celular\n\n'
      + 'Cuéntame qué tal te ha parecido o si necesitas ayuda con algo. 💜';
  }
  return `¡Hola! ⏳ Tu prueba gratis de Kontrol para ${n} termina en 1 o 2 días.\n\n`
    + 'Para seguir trabajando sin pausas, elige tu plan en "Mi plan" dentro de Kontrol. '
    + 'Si eres de los primeros 25 negocios, te quedas con el precio fundador para siempre. 🏅\n\n'
    + 'Si no eliges un plan, tu cuenta queda en pausa, pero tu información no se borra. ¿Te ayudo a escoger el plan que más te conviene? 💜';
}
